export const BANK_NAME = Object.freeze({
  AXIS: "axis",
  KOTAK: "kotak"
} as const);
export type BankName = typeof BANK_NAME[keyof typeof BANK_NAME];

export const HEADER_TITLE = Object.freeze({
  CARD: "card",
  REWARDS: "rewards",
  HISTORY: "history",
  MANAGE: "manage",
  DEPOSIT: "deposit"
} as const);
export type HeaderTitle = typeof HEADER_TITLE[keyof typeof HEADER_TITLE];

export const nomineeConfigReverse = Object.freeze({
  998: "Other",
  BRO: "Brother",
  DAU: "Daughter",
  FAT: "Father",
  HUS: "Husband",
  MOT: "Mother",
  SIS: "Sister",
  SON: "Son",
  WIF: "Wife"
} as const);

export const nomineeConfig = Object.freeze({
  Other: "998",
  Brother: "BRO",
  Daughter: "DAU",
  Father: "FAT",
  Husband: "HUS",
  Mother: "MOT",
  Sister: "SIS",
  Son: "SON",
  Wife: "WIF"
} as const);
export type NomineeLabel = keyof typeof nomineeConfig;
export type NomineeCode = typeof nomineeConfig[NomineeLabel];
